// extracted by mini-css-extract-plugin
module.exports = {"container":"_23uBZ","loader":"_1lOGf","close-button":"_2kq9C","closeButton":"_2kq9C"};